var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppsOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_260_26484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.54545 0H11.4546C15.0695 0 18 2.93051 18 6.54545V11.4546C18 15.0695 15.0695 18 11.4546 18H6.54545C2.93051 18.0001 0 15.0696 0 11.4546V6.54545C0 2.93051 2.93051 0 6.54545 0Z",
    fill: "#696969"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_260_26484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsOne);
export default __webpack_public_path__ + "static/media/apps_one.256c910665f443996c3c8f7ff85790d8.svg";
export { ForwardRef as ReactComponent };